import React, { useEffect, useState } from 'react'
import { CCol, CRow, CSpinner } from '@coreui/react'
import { api } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'

// Planes por empresa — ruta /superadmin/planes (vista de solo lectura).
// Datos expuestos por GET /api/superadmin/empresas (no se inventa endpoint).
const SuperAdminPlanesPage: React.FC = () => {
  const [empresas, setEmpresas] = useState<any[]>([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    api.get<any[]>('/superadmin/empresas')
      .then(setEmpresas)
      .catch(() => undefined)
      .finally(() => setCargando(false))
  }, [])

  // Campos de plan documentados en Empresa.cs (mapa de uso de campos libres
  // GX): EmpresaLibreNumerico2 = Plan SiprinIA, EmpresaLibreNumerico3 = Plan
  // TronIA, EmpresaLibreCaracter1 = EstadoPlanTronia, EmpresaDenominacion1 =
  // TokensConsumidos TronIA.
  const columnas: WwColumn[] = [
    { key: 'empresaCodigo', title: 'Empresa' },
    { key: 'empresaNombre', title: 'Nombre' },
    { key: 'empresaLibreNumerico2', title: 'Plan SiprinIA', type: 'number' },
    { key: 'empresaLibreNumerico3', title: 'Plan TronIA', type: 'number' },
    { key: 'empresaLibreCaracter1', title: 'Estado TronIA' },
    { key: 'empresaDenominacion1', title: 'Tokens Consumidos', type: 'number' },
  ]

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4 className="mb-0 fw-bold">Planes</h4>
          <small className="text-body-secondary">
            Planes por empresa (SiprinIA y TronIA) — vista de solo lectura.
          </small>
        </CCol>
      </CRow>
      {cargando ? (
        <div className="text-center py-4"><CSpinner color="primary" /></div>
      ) : (
        <WwGrid title="Planes" columns={columnas} rows={empresas} onTotalChange={() => undefined} />
      )}
    </>
  )
}

export default SuperAdminPlanesPage
